var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
export * from "./validate";
/*
export function toCamelCase(value: string) {
  return value.replace(/(\-[a-z])/g, (s) => s.toUpperCase().replace("-", ""));
}

export function toDashedCase(value: string) {
  return value.replace(/([A-Z])(?![ID])/g, (s) => "-" + s.toLowerCase());
}
*/
export function toCamelCase(value) {
    return value.replace(/-(id|[a-z])/gi, function (match, word) {
        if (word === "id") {
            return "ID";
        }
        else {
            return word.toUpperCase();
        }
    });
}
export function toDashedCase(value) {
    var words = value.match(/[A-Z]?[a-z]+|[A-Z]+(?![a-z])|\d+/g);
    if (!words)
        return "";
    return words
        .map(function (word, index) {
        var isLastWord = index === words.length - 1;
        var lowerCasedWord = word.toLowerCase();
        if (word === "ID" && !isLastWord) {
            return "id";
        }
        else if (!isLastWord) {
            return lowerCasedWord + "-";
        }
        else {
            return lowerCasedWord;
        }
    })
        .join("");
}
export function toTitleCase(str) {
    return str
        .toLowerCase()
        .replace(/\b\w+/g, function (word) { return word.charAt(0).toUpperCase() + word.slice(1); });
}
export function splitOnFirstOccurrence(text, character) {
    var index = text.indexOf(character);
    if (index !== -1) {
        var firstPart = text.substr(0, index);
        var secondPart = text.substr(index + 1);
        return [firstPart, secondPart];
    }
    return [text];
}
export function omitBeforeCharacter(text, character) {
    var _a = __read(splitOnFirstOccurrence(text, character), 2), t = _a[1];
    return t || text;
}
export var uniq = (function () {
    var map = {};
    return function uniq(key) {
        if (key === void 0) { key = "u"; }
        var value = (map[key] = (map[key] || 0) + 1);
        return "".concat(key, "_").concat(value);
    };
})();
export function ensureHTTPS(input) {
    var url = input.trim();
    if (!/^https?:\/\//i.test(url)) {
        url = "https://" + url;
    }
    try {
        var parsed = new URL(url);
        var isLocal = parsed.hostname === "localhost" ||
            /^\d+\.\d+\.\d+\.\d+$/.test(parsed.hostname);
        parsed.protocol = isLocal ? "http:" : "https:";
        var normalizedUrl = parsed.toString().replace(/\/$/, "");
        return normalizedUrl;
    }
    catch (_a) {
        return input;
    }
}
